import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getAcceptedPaymentMethodsQueryFn } from './queryFn/getAcceptedPaymentMethods.query';
import { getDealerTitleQueryFn } from './queryFn/getDealerTitle.query';
import { listOffersHttpQueryFn } from './queryFn/listOffersHttp.query';
export const DealerQueriesConfig = createQueriesConfig({
  listOffers: {
    queryFn: listOffersHttpQueryFn
  },
  getDealerTitle: {
    queryFn: getDealerTitleQueryFn
  },
  getAcceptedPaymentMethods: {
    queryFn: getAcceptedPaymentMethodsQueryFn
  }
});
//# sourceMappingURL=dealer.queries.js.map